import React from "react";
import { Link } from "react-router-dom";
import { personalInfo } from "../data";
import { ChevronDown } from "lucide-react";
import { SiGithub, SiLinkedin } from "react-icons/si";
import "./Home.css";

const Home = () => {
  return (
    <div className="portfolio">

      {/* Hero Section */}
      <section className="hero-section" id="home">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title">{personalInfo.name}</h1>
            <h2 className="hero-subtitle">{personalInfo.title}</h2>
            <p className="hero-description">{personalInfo.summary}</p>
            <div className="hero-buttons">
              <Link to="/projects" className="btn-primary">
                View Projects
              </Link>
              <Link to="/contact" className="btn-secondary">
                Get in Touch
              </Link>
            </div>
          </div>
          <Link 
            to="/about"
            className="scroll-indicator"
            aria-label="Scroll down"
          >
            <ChevronDown size={32} />
          </Link>
        </div>
      </section>
      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <p className="footer-text">
              © 2024 {personalInfo.name}. Built with React & Node.js
            </p>
            <div className="footer-social">
              <a href={personalInfo.linkedin} target="_blank" rel="noopener noreferrer" className="social-link">
                <SiLinkedin size={20} />
              </a>
              <a href={personalInfo.github} target="_blank" rel="noopener noreferrer" className="social-link">
                <SiGithub size={20} />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;